import React from 'react';
import QueueAnim from 'rc-queue-anim';
import { isImg } from '../utils';
import background1 from "../img/bground1.png"
import background2 from "../img/bground2.png"
import Sliders from "../Sliders/Sliders"

class Banner extends React.PureComponent {
  render() {
    const { ...currentProps } = this.props;
    const { dataSource } = currentProps;
    delete currentProps.dataSource;
    delete currentProps.isMobile;
      const Img=[
          background1,background2
      ]
    return (
      <div {...currentProps} {...dataSource.wrapper}>
          <Sliders
              images={Img}
              speed={0.5}
              delay={3}
              autoPlay={true}
              autoParse={true}
          />
        <QueueAnim
          key="QueueAnim"
          type={['bottom', 'top']}
          delay={200}
          {...dataSource.textWrapper}
        >
          <div key="title" {...dataSource.title}>
            {typeof dataSource.title.children === 'string' &&
            dataSource.title.children.match(isImg) ? (
              <img src={dataSource.title.children} width="100%" alt="img" />
            ) : (
              dataSource.title.children
            )}
          </div>
          <div key="content" {...dataSource.content}>
            {dataSource.content.children}
          </div>
        </QueueAnim>
      </div>
    );
  }
}
export default Banner;
